var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.055 7.519-2.982-2.982q-.37-.37-.741-.37c-.339 0-.733.256-.733.98v1.016a8.6 8.6 0 0 0-5.732 2.526 8.6 8.6 0 0 0-2.534 6.117.386.386 0 0 0 .695.231 9.87 9.87 0 0 1 7.571-3.97v.999c0 .724.395.981.733.981q.37-.001.741-.37l2.982-2.982c.29-.29.449-.676.449-1.088s-.16-.799-.45-1.088"
  })));
};
export default SvgShare;